export function extractUrlFilter(url) {
    const urlFilter = url.match(/^\/.+\/(.+)$/);
    const filter = urlFilter && urlFilter[1];

    return filter ? filter.replace(/-/ig, ' ') : null;
}